module.exports = "/_next/static/images/NoTransaction@2x-8260ce3417002333327cccd6022e8694.png";